import {
  BarChart3,
  CalendarClock,
  CalendarDays,
  LayoutDashboard,
  Palmtree,
  Presentation,
  Video,
} from 'lucide-react';
import type { ComponentType } from 'react';

/**
 * Canonical icon per `LOOP3_APPS[].id`, for `<AppSwitcher icons={LOOP3_APP_ICONS}>`.
 * Extracted verbatim from the identical `appSwitcherIcons` object that was
 * copy-pasted across admin/app/meetings/timeoff/timesheet's app-sidebar.tsx.
 *
 * `@loop3/ui` already carries a hard peer dependency on lucide-react (used by
 * Sidebar, AccountWidget, etc.), so keeping this map out of the package to
 * stay "lucide-free" bought nothing — it just forced five apps to keep their
 * own copy in sync by hand.
 */
export const LOOP3_APP_ICONS: Record<string, ComponentType<{ className?: string }>> = {
  platform: LayoutDashboard,
  admin: BarChart3,
  timesheet: CalendarDays,
  timeoff: Palmtree,
  calendar: CalendarClock,
  meetings: Video,
  demos: Presentation,
};
